import React from "react";
import pl from "shared/messages/pl";
import styles from "./targetProgressInfo.module.scss";
import classNames from "classnames";
import { getTargetValueFormat } from "shared/reports/utils/ReportUtils";
import { ScorecardGoal } from "goalsCard/service/api/models";
import { ScorecardGoalV3_PublicStatus } from "shared/service/api/generated";
import { goalCodes } from "shared/constants/reportConstants";
import { constants } from "shared/constants";

interface TargetProgressInfoProps {
    report: ScorecardGoal;
}

const TargetProgressInfo: React.FC<TargetProgressInfoProps> = (props: TargetProgressInfoProps) => {
    const calculateValueLeft = () => {
        if (props.report.targetValue === undefined || props.report.currentValue === undefined) {
            return undefined;
        }

        return Math.max(0, props.report.targetValue - props.report.currentValue);
    };

    const showWarningIndicator = props.report.status === ScorecardGoalV3_PublicStatus.NOK ? true : false;

    const getValuesSection = () => {
        switch (props.report.title) {
            case goalCodes.apeGz:
                return (
                    <div className={styles.values}>
                        {props.report.currentValue === undefined
                            ? constants.noValue
                            : getTargetValueFormat(props.report.currentValue, props.report.unitType)}
                    </div>
                );

            case goalCodes.lapse:
                return (
                    <div className={styles.values}>
                        <div>{getTargetValueFormat(props.report.targetValue, props.report.unitType)}</div>
                        <div>&nbsp;/&nbsp;{getTargetValueFormat(props.report.currentValue, props.report.unitType)}</div>
                    </div>
                );

            default:
                return (
                    <div className={styles.values}>
                        <div
                            className={classNames(styles.valuesCurrentValue, {
                                [styles.warning]: showWarningIndicator,
                            })}
                        >
                            {getTargetValueFormat(props.report.currentValue, props.report.unitType)}
                        </div>
                        <div>&nbsp;/&nbsp;{getTargetValueFormat(props.report.targetValue, props.report.unitType)}</div>
                    </div>
                );
        }
    };

    const getTargetSection = () => {
        switch (props.report.title) {
            case goalCodes.apeGz:
            case goalCodes.lapse:
                return null;
            default:
                return pl.reports.targetProgressInfo.targetLabel(
                    getTargetValueFormat(calculateValueLeft(), props.report.unitType)
                );
        }
    };

    return (
        <div className={styles.wrapper}>
            {getValuesSection()}
            <div>{getTargetSection()}</div>
        </div>
    );
};

export default TargetProgressInfo;
